<template>
  <div id="OrgEdit">
    <eb-header>
      <eb-break-crumb slot="breakCrumb" />
    </eb-header>
    <div class="content-header">
      <OrgEditHeaderCard>
        <OrgEditHeaderQuotationCard
          :orgInfo="orgInfo"
          :user="user"
        ></OrgEditHeaderQuotationCard>
      </OrgEditHeaderCard>
    </div>
    <div class="eb-line"></div>
    <div
      id="content-info"
      class="panel-box"
    >
      <OrgEditInfo
        :orgInfo="orgInfo"
        :user="user"
        :flagObj="flagObj"
        :approvalInfo="approvalInfo"
      ></OrgEditInfo>
    </div>
    <div class="eb-line"></div>
    <div
      id="content-business"
      class="panel-box"
    >
      <OrgEditAccountInfo :orgInfo="orgInfo"></OrgEditAccountInfo>
    </div>
    <div class="eb-line"></div>
    <div
      id="content-business1"
      class="panel-box"
    >
      <OrgEditTradeArea :orgInfo="orgInfo"></OrgEditTradeArea>
    </div>
    <div class="eb-line"></div>
    <div
      id="content-aptitude"
      class="panel-box"
    >
      <OrgEditQualification
        :orgAptitudeFileArr="orgAptitudeFileArr"
        @refreshOrgAptitudeFile="loadOrgAptitudeFile"
      ></OrgEditQualification>
    </div>
    <div class="eb-line"></div>
    <div
      id="content-team"
      class="panel-box"
    >
      <OrgEditTeam
        :companyTeamObj="companyTeamObj"
        :user="user"
      ></OrgEditTeam>
    </div>
    <div class="eb-button-group">
      <el-button
        @click="submitOrgInfo()"
        class="eb-button-group-btn eb-button-orange eb-button-big"
      >保存</el-button>
      <el-button
        :loading="flagObj.realNameButtonLoading"
        @click="applyRealName()"
        v-if="(orgInfo.departType==1 || orgInfo.departType==3) && flagObj.authBtnStatus==0"
        class="eb-button-group-btn eb-button-orange eb-button-big"
      >提交实名认证</el-button>
    </div>

    <OrgEditUploadLogo
      :user="user"
      :orgInfo="orgInfo"
    ></OrgEditUploadLogo>
    <OrgEditSocialContact :orgInfo="orgInfo"></OrgEditSocialContact>
    <OrgEditUploadAptitude
      :user="user"
      @refreshOrgAptitudeFile="loadOrgAptitudeFile"
    ></OrgEditUploadAptitude>
    <OrgTeamDetailDialog></OrgTeamDetailDialog>
    <OrgEditTeamSelectMemberDialog
      :user="user"
      :orgInfo="orgInfo"
    ></OrgEditTeamSelectMemberDialog>
    <OrgRealNameAuthenticationConfirm />
  </div>
</template>

<script>
import ebHeader from '@/components/common/eb-header';
import ebBreakCrumb from '@/components/common/eb-break-crumb';
import OrgEditHeaderCard from '@/components/org/edit/OrgEditHeaderCard';
import OrgEditHeaderQuotationCard from '@/components/org/edit/OrgEditHeaderQuotationCard';
import OrgEditInfo from '@/components/org/edit/OrgEditInfo';
import OrgEditAccountInfo from '@/components/org/edit/OrgEditAccountInfo';
import OrgEditTradeArea from '@/components/org/edit/OrgEditTradeArea';
import OrgEditQualification from '@/components/org/edit/OrgEditQualification';
import OrgEditTeam from '@/components/org/edit/OrgEditTeam';
import OrgEditUploadLogo from '@/components/org/edit/OrgEditUploadLogo';
import OrgEditUploadAptitude from '@/components/org/edit/OrgEditUploadAptitude';
import OrgEditSocialContact from '@/components/org/edit/OrgEditSocialContact';
import OrgTeamDetailDialog from '@/components/org/common/OrgTeamDetailDialog';
import OrgEditTeamSelectMemberDialog from '@/components/org/edit/OrgEditTeamSelectMemberDialog';
import OrgRealNameAuthenticationConfirm from '@/components/org/view/OrgRealNameAuthenticationConfirm';
import moment from 'moment';
import eventBus from '@/plugins/event-bus';
import { getDepartmentById, listDepartFile, updateDepartment } from '@/services/org/depart-service';
import { getUserByIds } from '@/services/user/user-service';

export default {
  name: 'OrgEdit',
  components: {
    ebHeader,
    ebBreakCrumb,
    OrgEditHeaderCard,
    OrgEditHeaderQuotationCard,
    OrgEditInfo,
    OrgEditAccountInfo,
    OrgEditTradeArea,
    OrgEditQualification,
    OrgEditTeam,
    OrgEditUploadLogo,
    OrgEditSocialContact,
    OrgEditUploadAptitude,
    OrgTeamDetailDialog,
    OrgEditTeamSelectMemberDialog,
    OrgRealNameAuthenticationConfirm
  },
  data() {
    return {
      user: this.$store.state.user.userInfo,
      orgInfo: {},
      flagObj: {
        busiTermEndStatus: '1',
        authStatusFlag: false,
        authBtnStatus: 1,
        authInfoStatus: true,
        authInfo: '',
        realNameButtonLoading: false
      },
      approvalInfo: {
        applyDepartId: ''
      },
      companyTeamObj: {
        companyTeamList: []
      },
      orgAptitudeFileArr: []
    };
  },
  created() {
    this.loadOrgInfo(true);
    this.loadOrgAptitudeFile();
    eventBus.$on('refreshOrgInfo', params => {
      this.loadOrgInfo(params);
    });
    eventBus.$on('refreshOrgTeamMember', params => {
      this.loadOrgTeamMember(params);
    });

    eventBus.$on('realNameSubmitOrgInfo', params => {
      this.submitOrgInfo();
    });
  },
  methods: {
    // 查询机构信息
    async loadOrgInfo(isLoadOrgTeamMember) {
      let departId = this.user.orgId;
      try {
        let data = await getDepartmentById(departId);
        let result = data.data;
        if (result.returnCode === '01') {
          this.orgInfo = result.depart;
          if (result.depart.busiTermEnd != null && result.depart.busiTermEnd !== '') {
            if (moment(result.depart.busiTermEnd).format('YYYY-MM-DD') === '2999-01-01') {
              this.flagObj.busiTermEndStatus = '1';
            } else {
              this.flagObj.busiTermEndStatus = '2';
            }
          }
          if (this.orgInfo.authStatus == null || this.orgInfo.authStatus === '' || this.orgInfo.authStatus === '0') {
            this.flagObj.authInfo = '未实名认证';
            this.flagObj.authBtnStatus = 0;
            this.flagObj.authInfoStatus = false;
          }
          if (this.orgInfo.authStatus === '1') {
            this.flagObj.authInfo = '已实名认证';
            this.flagObj.authBtnStatus = 1;
            this.flagObj.authInfoStatus = true;
            this.flagObj.authStatusFlag = true;
          }
          if (this.orgInfo.authStatus === '2') {
            this.flagObj.authInfo = '实名认证审核中';
            this.flagObj.authBtnStatus = 1;
            this.flagObj.authInfoStatus = true;
          }
          if (this.orgInfo.authStatus === '3') {
            this.flagObj.authInfo = '认证已失效，您需重新认证';
            this.flagObj.authBtnStatus = 0;
            this.flagObj.authInfoStatus = false;
          }
          if (this.orgInfo.authStatus === '4') {
            this.flagObj.authInfo = '认证未通过';
            this.flagObj.authBtnStatus = 0;
            this.flagObj.authInfoStatus = false;
          }
          if (this.orgInfo.companyTeam == null || this.orgInfo.companyTeam === '') {
            this.orgInfo.companyTeam = ',,,,';
          }
          if (isLoadOrgTeamMember) {
            this.loadOrgTeamMember(this.orgInfo.companyTeam);
          }
        } else {
          this.$message.error('加载企业信息失败！');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
      this.$root.layout.isLoading = false;
    },
    // 查询企业团队信息
    async loadOrgTeamMember(companyTeam) {
      if (companyTeam === ',,,,') {
        this.companyTeamObj.companyTeamList = ['', '', '', '', ''];
        return;
      }

      let orgUserIdArr = companyTeam.split(',');

      let orgUserIds = companyTeam
        .split(',')
        .filter(function(userId) {
          return userId !== '';
        })
        .join(',');
      if (orgUserIds === '') {
        this.companyTeamObj.companyTeamList = [];
        return;
      }
      try {
        let data = await getUserByIds(orgUserIds);
        let result = data.data;
        if (result.returnCode === '01') {
          let companyTeamListTemp = [];
          let existFlag = false;
          let orgUserIdArrLen = orgUserIdArr.length;
          let userListLen = result.userList.length;
          for (let i = 0; i < orgUserIdArrLen; i++) {
            for (let j = 0; j < userListLen; j++) {
              let orgUserId = orgUserIdArr[i];
              let userId = result.userList[j]['userId'].toString();
              if (orgUserId === userId) {
                companyTeamListTemp.push(result.userList[j]);
                existFlag = true;
              }
            }
            if (!existFlag) {
              companyTeamListTemp.push('');
            } else {
              existFlag = false;
            }
          }
          this.companyTeamObj.companyTeamList = companyTeamListTemp;
        } else {
          this.$message.error('加载机构团队成员信息失败！');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    // 查询企业资质信息
    async loadOrgAptitudeFile() {
      let orgId = this.user.orgId;
      try {
        let { data } = await listDepartFile(orgId);
        if (data.returnCode === '01') {
          this.orgAptitudeFileArr = data.data;
        } else {
          this.$message.error('加载企业资质文件失败！');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    async submitOrgInfo() {
      this.$root.layout.isLoading = true;
      if (this.orgInfo.creditCode == null || this.orgInfo.creditCode === '') {
        this.$message.error('请填写统一社会信用代码.');
        this.$root.layout.isLoading = false;
        return;
      }
      if (this.orgInfo.departName == null || this.orgInfo.departName === '') {
        this.$message.error('请填写企业名称.');
        this.$root.layout.isLoading = false;
        return;
      }
      if (this.orgInfo.businessLicense == null || this.orgInfo.businessLicense === '') {
        this.$message.error('请上传营业执照.');
        this.$root.layout.isLoading = false;
      }
      if (this.flagObj.busiTermEndStatus === '1') {
        this.orgInfo.busiTermEnd = '2999-01-01';
      }
      if (this.flagObj.busiTermEndStatus === '1') {
        this.orgInfo.busiTermEnd = moment(this.orgInfo.busiTermEnd).format('YYYY-MM-DD');
      }

      var params = {
        departId: this.user.orgId,
        departName: this.orgInfo.departName,
        departType: this.orgInfo.departType,
        registerAddress: this.orgInfo.registerAddress,
        registerCapital: this.orgInfo.registerCapital,
        creditCode: this.orgInfo.creditCode,
        legalPerson: this.orgInfo.legalPerson,
        registerPhone: this.orgInfo.registerPhone,
        openBank: this.orgInfo.openBank,
        bankAccount: this.orgInfo.bankAccount,
        companyProfile: this.orgInfo.companyProfile,
        companyUrl: this.orgInfo.companyUrl,
        wxId: this.orgInfo.wxId,
        wbId: this.orgInfo.wbId,
        profileOpen: this.orgInfo.profileOpen,
        areaOpen: this.orgInfo.areaOpen,
        aptitudeOpen: this.orgInfo.aptitudeOpen,
        teamOpen: this.orgInfo.teamOpen,
        cooperationOpen: this.orgInfo.cooperationOpen,
        businessLicense: this.orgInfo.businessLicense,
        orgType: this.orgInfo.orgType,
        foundingDate: this.momentDate(this.orgInfo.foundingDate),
        busiTermStart: this.momentDate(this.orgInfo.busiTermStart),
        busiTermEnd: this.momentDate(this.orgInfo.busiTermEnd),
        regOffice: this.orgInfo.regOffice,
        approvalDate: this.momentDate(this.orgInfo.approvalDate),
        regStatus: this.orgInfo.regStatus,
        busiScope: this.orgInfo.busiScope
      };
      params.isSendMsg = false; // 是否发送消息给部门成员
      try {
        let result = await updateDepartment(params);
        result = result.data;
        if (result.returnCode === '01') {
          this.$root.layout.isLoading = false;
          this.$message.success('修改机构信息成功');
          this.$router.push('/org/detail');
        } else if (result.returnCode === '04') {
          this.$root.layout.isLoading = false;
          this.$message.error('机构名称已注册！');
        } else {
          this.$root.layout.isLoading = false;
          this.$message.error('修改机构信息失败！');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    // 格式化日期
    momentDate(date) {
      if (moment(date).isValid()) {
        return moment(date).format('YYYY-MM-DD');
      } else {
        return null;
      }
    },
    applyRealName() {
      this.flagObj.realNameButtonLoading = true;
      eventBus.$emit('OrgApplyRealName', '');
    }
  }
};
</script>

<style scoped lang="less">
.content-header {
  padding: 33px 33px 33px 33px;
}
</style>
